var map = {
	"./cm1.jpeg": 3993,
	"./cm2.jpeg": 6312,
	"./cm3.jpeg": 4831,
	"./cm4.jpeg": 5302,
	"./cm5.jpeg": 4045,
	"./roadsafety1.jpg": 5036,
	"./roadsafety10.jpg": 5230,
	"./roadsafety11.jpg": 9627,
	"./roadsafety12.jpg": 4972,
	"./roadsafety13.jpg": 5497,
	"./roadsafety14.jpg": 5130,
	"./roadsafety15.jpg": 6519,
	"./roadsafety16.jpg": 6536,
	"./roadsafety17.jpg": 853,
	"./roadsafety18.jpg": 4038,
	"./roadsafety19.jpg": 4147,
	"./roadsafety2.jpg": 203,
	"./roadsafety3.jpg": 718,
	"./roadsafety4.jpg": 7781,
	"./roadsafety5.jpg": 6600,
	"./roadsafety6.jpg": 9447,
	"./roadsafety7.jpg": 7290,
	"./roadsafety8.jpg": 9345,
	"./roadsafety9.jpg": 1972,
	"./safeunsafe1.jpeg": 5724,
	"./safeunsafe2.jpeg": 5597,
	"./safeunsafe3.jpeg": 7334,
	"./safeunsafe4.jpeg": 6927,
	"./safeunsafe5.jpeg": 2984,
	"./safeunsafe6.jpeg": 1721,
	"./workshop1.jpg": 7709,
	"./workshop2.jpg": 1778,
	"./workshop3.jpg": 3487,
	"./workshop4.jpg": 5700,
	"./workshop5.jpg": 33,
	"./workshop6.jpg": 2278,
	"./workshop7.jpg": 1763,
	"./workshop8.jpg": 7304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2805;